import HttpHelpers from '../helpers';

const PaymentsApiEndpoints = {
  getPayments: (params) => {
    return HttpHelpers.authenticatedAxios
      .get('user/payment', { params })
      .then((response) => response.data);
  },
  getPaymentDetails: (paymentId) => {
    return HttpHelpers.authenticatedAxios
      .get(`payment/${paymentId}`)
      .then((response) => response.data);
  },
};

export default PaymentsApiEndpoints;
